import {
  OrderJoinCargoOrderRide,
  OrderJoinPreviewRideSeqItem,
  OrderJoinPreviewRideWaypoint,
  OrderJoinPreviewRideWaypointMeta,
  OrderJoinPreviewRideWaypointMetaSubject,
  OrderJoinPreviewRideWaypointMetaSubjectList,
} from "../../../../../common/services/order/join/order-join";
import {
  RideSolvedParamsRailyRide,
  RideSolvedParamsRideSeqItem,
  RideSolvedParamsRideWaypoint,
  RideSolvedParamsRideWaypointGroup,
  RideSolvedParamsRideWaypointMeta,
  RideSolvedParamsRideWaypointMetaSubjectList,
  RideSolvedParamsRideWaypointMetaSubjects,
} from "../../../../../common/services/ride/solved/ride-solved-params";

const createSeqItemMetaSubject = (
  subject: OrderJoinPreviewRideWaypointMetaSubject,
): RideSolvedParamsRideWaypointMetaSubjects => {
  return {
    id: subject.id,
  };
};

const createSeqItemMetaSubjects = (
  subjects: OrderJoinPreviewRideWaypointMetaSubject[],
): RideSolvedParamsRideWaypointMetaSubjects[] => {
  return subjects.map(createSeqItemMetaSubject);
};

const createSeqItemMetaSubjectList = (
  subjectList: OrderJoinPreviewRideWaypointMetaSubjectList,
): RideSolvedParamsRideWaypointMetaSubjectList => {
  return {
    subjects: createSeqItemMetaSubjects(subjectList.subjects),
  };
};

const createSeqItemMeta = (
  meta: OrderJoinPreviewRideWaypointMeta,
): RideSolvedParamsRideWaypointMeta => {
  return {
    cargoEnter: createSeqItemMetaSubjectList(meta.cargoEnter),
    cargoExit: createSeqItemMetaSubjectList(meta.cargoExit),
    id: meta.id,
  };
};

const createSeqItemNodeItem = (
  node: OrderJoinPreviewRideWaypoint,
): RideSolvedParamsRideWaypoint => {
  return {
    displayName: node.displayName,
    haltingTime: node.haltingTime,
    lat: node.lat,
    lon: node.lon,
    meta: createSeqItemMeta(node.meta),
    time: node.time,
  };
};

const createSeqItem = (
  seqItem: OrderJoinPreviewRideSeqItem,
): RideSolvedParamsRideSeqItem => {
  if ("seq" in seqItem) {
    const group: RideSolvedParamsRideWaypointGroup = {
      seq: seqItem.seq.map(createSeqItemNodeItem),
      sequenceOrder: seqItem.sequenceOrder,
    };
    return group;
  } else {
    return createSeqItemNodeItem(seqItem);
  }
};

const createSeq = (
  seq: OrderJoinPreviewRideSeqItem[],
): RideSolvedParamsRideSeqItem[] => {
  return seq.map(createSeqItem);
};

const create = (ride: OrderJoinCargoOrderRide): RideSolvedParamsRailyRide => {
  return {
    seq: createSeq(ride.seq),
    sequenceOrder: ride.sequenceOrder,
  };
};

const orderJoinRideSolvedLoadParamsFactory = {
  create,
};

export default orderJoinRideSolvedLoadParamsFactory;
